import React from 'react';
import { Link } from '@reach/router';
import { connect } from '../redux/store';
import { PageTitle } from './shared/PageTitle';
import { I18n } from '@kineticdata/react';
import {
  Card,
  CardCol,
  CardRow,
  C,
  selectServicesKapp,
  selectSurveyKapp,
} from '@kineticdata/bundle-common';

const SettingsCard = ({ to, href, icon, name, description }) => (
  <Card to={to} href={href} color="light" components={{ Link }}>
    <CardCol>
      <CardRow center>
        <span
          className={`fa fa-${(icon || 'cog').replace(
            /^fa-/i,
            '',
          )} text-primary fa-6x p-2`}
        />
      </CardRow>
      <CardRow type="title" center>
        <I18n>{name}</I18n>
      </CardRow>
      <CardRow className="text-muted pb-3" center>
        <span className="text-truncate">
          <I18n>{description}</I18n>
        </span>
      </CardRow>
    </CardCol>
  </Card>
);

const SettingsComponent = ({
  servicesKapp,
  surveyKapp,
  isSpaceAdmin,
  hasAdminFormsAccess,
  hasApprovalManagementAccess,
  hasCatalogManagementAccess,
  hasDatastoreAccess,
  hasNotificationAccess,
  hasRobotAccess,
  hasCalendarAccess,
  hasSchedulerAccess,
  hasTeamAccess,
  hasUserAccess,
  hasSurveyAccess,
}) => {
  const settingsPages = [
    hasAdminFormsAccess && {
      to: '/settings/adminforms',
      name: 'Admin Forms',
      description: 'Manage reference data.',
      icon: 'fa-archive',
    },
    hasApprovalManagementAccess && {
      to: '/settings/approvalmanagement',
      name: 'Approval Management',
      description: 'Manage approval groups.',
      icon: 'fa-clipboard',
    },
    hasCatalogManagementAccess && {
      to: `/kapps/${servicesKapp.slug}/settings/catalog`,
      name: 'Catalog Management',
      description: 'Manage catalog content.',
      icon: 'fa-folder',
    },
    hasDatastoreAccess && {
      to: '/settings/datastore',
      name: 'Datastore Forms',
      description: 'Manage system data.',
      icon: 'fa-hdd',
    },
    hasNotificationAccess && {
      to: '/settings/notifications',
      name: 'Notifications',
      description: 'Manage email notifications.',
      icon: 'fa-envelope',
    },
    {
      to: '/profile',
      name: 'Profile',
      description: 'Manage your user profile.',
      icon: 'fa-user-edit',
    },
    hasRobotAccess && {
      to: '/settings/robots',
      name: 'Robots',
      description: 'Manage robots.',
      icon: 'fa-robot',
    },
    hasSchedulerAccess && {
      to: '/settings/schedulers',
      name: 'Schedulers',
      description: 'Manage schedulers.',
      icon: 'fa-calendar-plus',
    },
    hasSurveyAccess && {
      to: `/kapps/${surveyKapp.slug}/admin`,
      name: 'Survey Management',
      description: 'Manage surveys.',
      icon: 'fa-clipboard',
    },
    // isSpaceAdmin && {
    //   to: '/settings/space',
    //   name: 'Space Settings',
    //   description: 'Manage space settings.',
    //   icon: 'fa-cog',
    // },
    hasTeamAccess && {
      to: '/settings/teams',
      name: 'Team Management',
      description: 'Manage teams.',
      icon: 'fa-users-cog',
    },
    hasUserAccess && {
      to: '/settings/users',
      name: 'User Management',
      description: 'Manage users.',
      icon: 'fa-user-cog',
    },
  ].filter(Boolean);

  return (
    <div className="page-container">
      <div className="page-panel">
        <PageTitle title={C.SETTINGS_LABEL} />

        <div className="cards cards--thirds">
          {settingsPages.map(page => <SettingsCard key={page.to} {...page} />)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    loading,
    errors,
    agreements,
    ...accessProps
  } = state.settingsApp.toJS();
  return {
    servicesKapp: selectServicesKapp(state),
    surveyKapp: selectSurveyKapp(state),
    isSpaceAdmin: state.app.profile.spaceAdmin,
    ...accessProps,
  };
};

export const Settings = connect(mapStateToProps)(SettingsComponent);
